/**
 * Initial empty state shown until the patient has picked BOTH a location AND a device.
 * Soft helper copy guides them through the next step.
 */
export default function EmptyState({ hasLocation }) {
  // Only location is required to surface results. Device is an optional
  // refinement applied on top.
  const message = hasLocation
    ? null  // shouldn't render in this state — caller decides what to show
    : 'Enter your CITY or ZIP code to find nearby providers.';

  return (
    <div className="pf-emptystate">
      <div className="pf-emptystate__icon" aria-hidden="true">📍</div>
      <p className="pf-emptystate__message">{message}</p>
    </div>
  );
}
